import * as React from "react";
import "./carnet.scss";

const Estudiante = ({ plantilla, estudiante }) => (
  <div
    className="carnet"
    style={{ backgroundImage: `url(${plantilla?.Path})` }}
  >
    {/* <h1>Universidad Francisco Gavidia</h1> */}
    <div style={{ marginTop: "118px" }} />
    <p className="ciclo">Ciclo: {estudiante?.CicloCarnetizacion}</p>
    <div className="wrap-foto">
      <img
        src={estudiante?.Foto}
        alt=""
        className="foto-estudiante img-fluid h-100"
      />
    </div>
    <div className="qr-container">
      <img src={estudiante?.Qr} alt="" className="code-qr" />
    </div>
    <p className="carrera">{estudiante?.NombreCarrera}</p>
    <hr className="divider"></hr>
    <p className="nombres">{estudiante?.Nombres}</p>
    <p className="nombres">{estudiante?.Apellidos}</p>
    <p className="carnetS">{estudiante?.Carnet}</p>
    <p className="vencimiento" style={{ right: "-20px" }}>{estudiante?.FechaVencimientoCarnet}</p>
  </div>
);

const Colaborador = ({ plantilla, estudiante }) => (
  <div
    className="carnet"
    style={{ backgroundImage: `url(${plantilla?.Path})` }}
  >
    {/* <h1>Universidad Francisco Gavidia</h1> */}
    <div style={{ marginTop: "118px" }} />
    <div className="wrap-foto-colaborador">
      <img
        src={estudiante?.Foto}
        alt=""
        className="foto-estudiante img-fluid h-100"
      />
    </div>
    <div className="qr-container">
      <img src={estudiante?.Qr} alt="" className="code-qr" />
    </div>

    <p className="carrera">
      <p>{estudiante?.Direccion}</p>
    </p>
    <p className="cargo">{estudiante?.Cargo}</p>
    <hr className="divider"></hr>
    <p className="nombres">{estudiante?.Nombres}</p>
    <p className="nombres">{estudiante?.Apellidos}</p>
    <p className="carnetS">{estudiante?.Carnet}</p>
    <p className="vencimiento">{estudiante?.FechaVencimientoCarnet}</p>
  </div>
);

const Docente = ({ plantilla, estudiante }) => (
  <div
    className="carnet"
    style={{ backgroundImage: `url(${plantilla?.Path})` }}
  >
    {/* <h1>Universidad Francisco Gavidia</h1> */}
    <div style={{ marginTop: "118px" }} />
    <p className="ciclo">Ciclo: {estudiante?.CicloCarnetizacion}</p>
    <div className="wrap-foto">
      <img
        src={estudiante?.Foto}
        alt=""
        className="foto-estudiante img-fluid h-100"
      />
    </div>
    <div className="qr-container">
      <img src={estudiante?.Qr} alt="" className="code-qr" />
    </div>
    <p className="carrera">{estudiante?.TipoContrato}</p>
    <hr className="divider"></hr>
    <p className="nombres">{estudiante?.Nombres}</p>
    <p className="nombres">{estudiante?.Apellidos}</p>
    <p className="carnetS">{estudiante?.Carnet}</p>
    <p className="vencimiento">{estudiante?.FechaVencimientoCarnet}</p>
  </div>
);

const Egresado = ({ plantilla, estudiante }) => (
  <div
    className="carnet"
    style={{ backgroundImage: `url(${plantilla?.Path})` }}
  >
    <div style={{ marginTop: "118px" }} />
    <p className="ciclo">Ciclo: {estudiante?.CicloCarnetizacion}</p>
    <div className="wrap-foto">
      <img
        src={estudiante?.Foto}
        alt=""
        className="foto-estudiante img-fluid h-100"
      />
    </div>
    <div className="qr-container">
      <img src={estudiante?.Qr} alt="" className="code-qr" />
    </div>
    <p className="carrera">{estudiante?.NombreCarrera}</p>
    <hr className="divider"></hr>
    <p className="nombres">{estudiante?.Nombres}</p>
    <p className="nombres">{estudiante?.Apellidos}</p>
    <p className="carnetS">{estudiante?.Carnet}</p>
    <p className="vencimiento" style={{ right: "-19px" }}>{estudiante?.FechaVencimientoCarnet}</p>
  </div>
);

const Postgrado = ({ plantilla, estudiante }) => (
  <div
    className="carnet"
    style={{ backgroundImage: `url(${plantilla?.Path})` }}
  >
    {/* <h1>Universidad Francisco Gavidia</h1> */}
    <div style={{ marginTop: "118px" }} />
    <p className="ciclo">Ciclo: {estudiante?.CicloCarnetizacion}</p>
    <div className="wrap-foto">
      <img
        src={estudiante?.Foto}
        alt=""
        className="foto-estudiante img-fluid h-100"
      />
    </div>
    <div className="qr-container">
      <img src={estudiante?.Qr} alt="" className="code-qr" />
    </div>
    <p className="carrera">{estudiante?.NombreMaestria}</p>
    <hr className="divider"></hr>
    <p className="nombres">{estudiante?.Nombres}</p>
    <p className="nombres">{estudiante?.Apellidos}</p>
    <p className="carnetS">{estudiante?.Carnet}</p>
    <p className="vencimiento">{estudiante?.FechaVencimientoCarnet}</p>
  </div>
);

const Selector = ({ plantilla, estudiante }) => {
  if (estudiante?.TipoCarnet === "PREGRADO") {
    return <Estudiante plantilla={plantilla} estudiante={estudiante} />;
  }

  if (estudiante?.TipoCarnet === "EMPLEADO") {
    return <Colaborador plantilla={plantilla} estudiante={estudiante} />;
  }

  if (estudiante?.TipoCarnet === "DOCENTE") {
    return <Docente plantilla={plantilla} estudiante={estudiante} />;
  }

  if (estudiante?.TipoCarnet === "EGRESADO") {
    return <Egresado plantilla={plantilla} estudiante={estudiante} />;
  }

  if (estudiante?.TipoCarnet === "POSTGRADO") {
    return <Postgrado plantilla={plantilla} estudiante={estudiante} />;
  }
};

export const Carnet = ({ plantilla, estudiante }) => (
  <>
    <Selector plantilla={plantilla} estudiante={estudiante} />
  </>
);
